import React, { useEffect, useContext, useState } from "react";

// Context
import AppContext from "./AppContext";

// Components
import Color from "./Color";
import Alert from "./Alert";

// Css
import "./ColorBar.css";
import "@simonwep/pickr/dist/themes/monolith.min.css";

// Scripts
import Pickr from "@simonwep/pickr";
import randomColor from "randomcolor";
import hslToHex from "./scripts/hslToHex";

// Matterial UI
// #Icons
import ColorizeIcon from "@material-ui/icons/Colorize";
import IconButton from "@material-ui/core/IconButton";
import LooksIcon from "@material-ui/icons/Looks";
// #Transitions
import Zoom from "@material-ui/core/Zoom";

// Global Variables

const randomColors = randomColor({ count: 100 });
let colors = [];
colors = [
  "#000000",
  "#ff0000",
  "#ff0099",
  "#cc00cc",
  "#0000cc",
  "#cccc00",
  "#00ff00",
  ...randomColors,
];

function ColorBar({ parent }) {
  const { appContext, setAppContext } = useContext(AppContext);
  const [rainbowAlert, setRainbowAlert] = useState(false);
  const rainbowText = () => {
    setRainbowAlert(false);
    setAppContext((prev) => ({
      ...prev,
      foreColorState: false,
    }));

    const text = document.querySelector(".textEditor").innerText;
    let coloredText = "";
    [...text].forEach((letter, i) => {
      if (letter.match(/[</>]/g)) {
        console.log("yes");
      } else {
        const magicNumber = 360 * (i / text.length);
        const color = hslToHex(magicNumber, 80, 50);
        coloredText += `<font color="${color}">${letter}</font>`;
      }
    });
    document.querySelector(".textEditor").innerHTML = coloredText;
    document.querySelector(".textEditor").focus();
  };

  useEffect(() => {
    Pickr.create({
      el: ".color-pickr",
      useAsButton: true,
      theme: "monolith",
      position: "top",
      appClass: "custom-class",
      components: {
        preview: true,
        hue: true,
        interaction: {
          input: true,
          clear: true,
        },
      },
    })
      .on("change", (color) => {
        document
          .querySelectorAll(".color")
          .forEach((element) => element.classList.remove("color-picked"));
        setAppContext((prev) => ({
          ...prev,
          foreColor: color.toHEXA().toString(),
          foreColorState: true,
        }));
        document.querySelector(".textEditor").focus();
        document.execCommand("foreColor", false, color.toHEXA().toString());
      })
      .on("show", (color) => {
        document.querySelector(".textEditor").focus();
      });
  }, []);

  return (
    <>
      <Zoom in={true} style={{ transitionDuration: "0.5s" }}>
        <div
          className={
            parent == "toolbar"
              ? "toolbar__color-bar atToolbar"
              : "toolbar__color-bar atSmallbar"
          }
        >
          <Alert
            open={rainbowAlert}
            state={setRainbowAlert}
            func={rainbowText}
            title="Warning!"
            description="All changes to the text will be discarded. Are you sure you want to continue?"
          />
          <div
            className="toolbar__color-table"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            {colors.map((hue) => (
              <Color hue={hue} key={hue} />
            ))}
          </div>

          <button className="color-pickr" style={{ display: "none" }}></button>
          <IconButton
            onClick={() => {
              document.getElementsByClassName("color-pickr")[0].click();
            }}
            key="123"
          >
            <ColorizeIcon
              style={{ color: appContext.foreColor, fontSize: 30 }}
            />
          </IconButton>
          <IconButton
            id="rainbowfy"
            key="1234"
            onClick={() => {
              setRainbowAlert(true);
            }}
          >
            <LooksIcon style={{ fontSize: 30, color: "#eb8f8f" }} />
          </IconButton>
        </div>
      </Zoom>
    </>
  );
}

export default ColorBar;
